import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "@/styles/index.scss"; // 公共样式
import ElementUI from 'element-ui';
//样式文件需要单独引入
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import * as vConsole from 'vconsole'

if (process.env.NODE_ENV !== 'production') {
  new vConsole()
}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
